import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';
import { useRouter } from 'next/router';

export const useMealPlanInSessionEnabled = (): boolean => {
  const router = useRouter();
  const growthBookEnabled = useFeatureIsOn(
    GROWTHBOOK_FEATURE_FLAGS.MEAL_PLAN_IN_SESSION,
  );

  const queryParam = router.query['mealPlanInSession'];
  if (queryParam === 'true') {
    return true;
  }
  if (queryParam === 'false') {
    return false;
  }

  return growthBookEnabled;
};
